const FileIcon = () => {
  return (
    <svg
      width="32"
      height="36"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 14.3043H22.6667M9.33333 20.9565H17.6667M1 14.3043C1 8.03301 1 4.89651 2.95333 2.94909C4.905 1 8.04833 1 14.3333 1H17.6667C23.9517 1 27.095 1 29.0467 2.94909C31 4.89651 31 8.03301 31 14.3043V20.9565C31 27.2279 31 30.3644 29.0467 32.3118C27.095 34.2609 23.9517 34.2609 17.6667 34.2609H14.3333C8.04833 34.2609 4.905 34.2609 2.95333 32.3118C1 30.3644 1 27.2279 1 20.9565V14.3043Z"
        stroke="#77778C"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export default FileIcon;
